<template>
  <div class="categories-page">

    <!-- Page title — title/lg §1.2 -->
    <h1 class="categories-page__title">{{ wordTypes[type - 1] }}</h1>

    <!-- ── Rails: one per category (≥ 3 items) ── -->
    <div class="categories-page__rails" v-if="categories.length > 0">
      <section
        v-for="cat in categories.filter(x => x.items.length > 2)"
        :key="cat.id"
        class="rail"
        :class="{ 'rail--top10': cat.id === 195 }"
        :aria-label="cat.name"
      >
        <div class="rail__header">
          <router-link
            :to="'/category/' + cat.id + '/type/' + type"
            class="rail__title-link"
          >
            <h2 class="rail__title">{{ cat.name }}</h2>
          </router-link>
          <router-link
            :to="'/category/' + cat.id + '/type/' + type"
            class="rail__explore"
            :aria-label="'כל הפריטים ב' + cat.name"
          >
            כל הפריטים
            <svg
              class="rail__chevron"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              aria-hidden="true"
            >
              <path d="M15 18l-6-6 6-6"/>
            </svg>
          </router-link>
        </div>

        <div
          class="rail__scroll-wrap splide rail__splide splide--loop splide--rtl splide--draggable is-active is-initialized"
          :class="{ 'is-hovering': cat._hovering }"
        >
           <button
            class="rail__nav rail__nav--prev"
            type="button"
            aria-label="הקודם"
            :aria-controls="'rail-list-' + cat.id"
            @click="scrollRail($event, -1)"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>
          </button>
          <button
            class="rail__nav rail__nav--next"
            type="button"
            aria-label="הבא"
            :aria-controls="'rail-list-' + cat.id"
            @click="scrollRail($event, 1)"
          >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>  
          </button>
          <ul
            :id="'rail-list-' + cat.id"
            class="rail__list"
            :class="{ 'is-hovering': cat._hovering }"
            role="list"
            @mouseenter="cat._hovering = true"
            @mouseleave="cat._hovering = false"
          >
            <item-tpl
              v-for="item in cat.items"
              :key="item.id"
              :item="item"
            />
          </ul>
          <div class="rail__fade" aria-hidden="true"></div>
        </div>
      </section>
    </div>

  </div>
</template>

<script>
import itemTpl from './item_tpl.vue';

export default {
  components: { itemTpl },

  data() {
    return {
      promoted: [],
      categories: [],
      category: [],
      id: this.$route.params.id,
      type: this.$route.params.type,
      wordType: ['movie', 'series'],
      wordTypes: ['ראיונות', 'סדרות'],
    };
  },

  computed: {
    activeItems() {
      let typein = this.type;
      let movietypein;
      if (typein) {
        movietypein = this.wordType[typein - 1];
      }
      return this.categories[0].items.filter(function (categoryType) {
        if (movietypein)
          return categoryType.type === movietypein;
        else
          return categoryType.type === 'movie' || categoryType.type === 'series';
      });
    },
  },

  methods: {
    scrollRail(event, dir) {
      const btn = event.currentTarget;
      const list = btn.parentElement.querySelector('.rail__list');
      if (!list) return;
      const isRtl = getComputedStyle(list).direction === 'rtl';
      const sign = isRtl ? -dir : dir;
      list.scrollBy({ left: list.clientWidth * 0.8 * sign, behavior: 'smooth' });
    },
  },

  updated() {
    window.dispatchEvent(new Event('resize'));
  },

  created() {
    this.$emit('show_loader');
    var self = this;

    this.api_call({
      url: 'categories',
      data: { type: this.wordType[this.type - 1] },
      onComplete: function (data) {
        for (var i in data.data.data.promoted) {
          data.data.data.promoted[i].is_active = i == 0;
        }
        self.promoted = data.data.data.promoted;
        var cats = data.data.data.categories;
        for (var ci in cats) { cats[ci]._hovering = false; }
        self.categories = cats;
        self.category = data.data.data.category;
        self.$emit('loaded');
      },
    });
  },
};
</script>

<style scoped lang="scss">
/* ── Page wrapper ── */
.categories-page {
  background: var(--color-bg);
  min-height: 100vh;
  max-width: 100vw;
  overflow-x: hidden;
  margin: 0 auto;
  padding-block-start: var(--space-8);
  padding-block-end: var(--space-12);
}

/* ── Page title — title/lg §1.2: 28px / 700 / -0.4px ── */
.categories-page__title {
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: -0.4px;
  color: var(--color-text);
  font-family: var(--font-hebrew);
  text-align: center;
  margin-block-start: 0;
  margin-block-end: var(--space-8);
  padding-inline: var(--space-8);
}

/* ── Rails container ── */
.categories-page__rails {
  display: flex;
  flex-direction: column;
  padding-block-end: var(--space-12);
}

/* ── Rail ── */
.rail {
  margin-block-end: 56px;
}

/* Rail header */
.rail__header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-3);
  padding-inline: var(--rail-padding-inline, 36px);
  padding-block-end: var(--space-3);
  position: relative;
  z-index: 12;
}

.rail__title-link {
  text-decoration: none;
}
.rail__title-link:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
  border-radius: 2px;
}

.rail__title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.3px;
  color: var(--color-text);
  font-family: var(--font-hebrew);
  text-align: start;
  transition: font-size 200ms ease, text-shadow 200ms ease, color var(--duration-fast) var(--easing-default);
}
.rail:hover .rail__title {
  font-size: 23px;
  text-shadow: 0 0 8px rgba(255,255,255,0.1);
}
.rail__title-link:hover .rail__title {
  color: var(--color-textMuted);
}

/* Explore-all link — hidden until rail hover */
.rail__explore {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--color-textMuted);
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  font-family: var(--font-hebrew);
  opacity: 0;
  transform: translateX(8px);
  transition: opacity 200ms ease, transform 200ms ease, color var(--duration-fast) var(--easing-default);
}
[dir="rtl"] .rail__explore {
  transform: translateX(-8px);
}
.rail:hover .rail__explore {
  opacity: 1;
  transform: translateX(0);
}
.rail__explore:hover {
  color: var(--color-text);
}
.rail__explore:focus-visible {
  opacity: 1;
  transform: none;
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
  border-radius: 2px;
}

/* Chevron — flip in RTL */
.rail__chevron {
  flex-shrink: 0;
  transition: transform var(--duration-fast) var(--easing-default);
}
[dir="rtl"] .rail__chevron {
  transform: scaleX(-1);
}

/* Scroll wrapper */
.rail__scroll-wrap {
  position: relative;
  display: flex;
  flex-direction: column;
  padding-inline: var(--rail-padding-inline, 36px);
}

/* Card list — horizontally-scrollable flex row */
.rail__list {
  display: flex;
  gap: var(--rail-gap, 6px);
  padding: 50px 0 50px;
  margin-block: -50px;
  overflow-x: auto;
  scroll-behavior: smooth;
  scroll-snap-type: x proximity;
  scrollbar-width: none;
  -ms-overflow-style: none;
  overflow: hidden;
  list-style: none;
}
.rail__list::-webkit-scrollbar {
  display: none;
}

/* Trailing-edge fade mask */


/* ── Rail nav arrows — always visible carousel chevrons ── */
.rail__nav {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 56px;
  height: auto;
  transform: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 0;
  cursor: pointer;
  z-index: 20;
  opacity: 0.85;
  pointer-events: auto;
  transition: opacity 180ms ease, background 180ms ease;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
}
.rail__nav--prev {
  right: 0;
  left: auto;
  background: linear-gradient(to left, rgba(0, 0, 0, 0.65) 20%, transparent 100%);
}
.rail__nav--next {
  left: 0;
  right: auto;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.65) 20%, transparent 100%);
}
.rail__nav svg {
  width: 24px;
  height: 24px;
}
.rail__nav:hover {
  opacity: 1;
}
.rail__nav:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: -4px;
}
@media (hover: none) {
  .rail__nav {
    display: none;
  }
}

/* ── Rail dim ── */
.rail__list.is-hovering :deep(.poster-card) {
  opacity: 0.55;
  transition: opacity 200ms ease;
}
.rail__list.is-hovering :deep(.poster-card:hover) {
  opacity: 1;
}

/* ── Mobile adjustments ── */
@media (max-width: 640px) {
  .rail__scroll-wrap {
    padding-inline: var(--rail-padding-inline, 16px);
  }

  .rail__header {
    padding: 0 var(--rail-padding-inline, 16px) 12px;
  }
  .rail__title {
    font-size: 16px;
  }
  .rail:hover .rail__title {
    font-size: 17px;
  }
  .categories-page__title {
    font-size: 22px;
    padding-inline: var(--space-4);
  }
}
</style>
